export const LINES = 'lines';
export const SHAPE = 'shape';
